/* RESSONÂNCIA CURATIVA — rc.js */
(function () {
  'use strict';

  function brl(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
  }
  function claim(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ═══ MENU DRAWER ═══ */
  function drawer() {
    var d = document.querySelector('[data-rc-drawer]');
    if (!d || !claim(d, 'rcBound')) return;
    function open() { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { d.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-rc-burger]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = d.classList.contains('is-open');
        b.setAttribute('aria-expanded', on ? 'false' : 'true');
        on ? close() : open();
      });
    });
    d.querySelectorAll('[data-rc-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ═══ GALERIA ═══ */
  function gallery() {
    document.querySelectorAll('[data-rc-gal]').forEach(function (root) {
      if (!claim(root, 'rcBound')) return;
      var track = root.querySelector('[data-rc-gal-track]');
      if (!track) return;
      var dots = [].slice.call(root.querySelectorAll('[data-rc-gal-dot]'));
      var thumbs = [].slice.call(root.querySelectorAll('[data-rc-gal-thumb]'));
      function mark(i) {
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          mark(Math.round(track.scrollLeft / track.clientWidth));
        }, 60);
      }, { passive: true });
      dots.concat(thumbs).forEach(function (el) {
        el.addEventListener('click', function () {
          var i = +el.dataset.i;
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          mark(i);
        });
      });
    });
  }

  /* ═══ OFERTA ═══ */
  function money(str) {
    if (!str) return 0;
    var s = String(str).replace(/[^\d.,]/g, '');
    if (s.indexOf(',') > -1) { s = s.replace(/\./g, '').replace(',', '.'); }
    else { s = s.replace(/\./g, ''); }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function Offer(root) {
    this.root = root;
    this.tiers = [].slice.call(root.querySelectorAll('[data-rc-tier]'));
    if (!this.tiers.length) return;
    this.btn = root.querySelector('[data-rc-buy]');
    var l = this.btn && this.btn.querySelector('[data-rc-buy-label]');
    this.ctaLabel = l ? l.textContent.trim() : 'Finalizar pedido';
    this.active = root.querySelector('[data-rc-tier].is-on') || this.tiers[0];
    this.init();
  }

  Offer.prototype.init = function () {
    var self = this;

    this.tiers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-rc-freq]') || e.target.closest('[data-rc-bump]')) return;
        self.select(el);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.select(el); }
      });
    });

    this.root.querySelectorAll('[data-rc-freq]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = b.closest('[data-rc-pick-group]');
        group.querySelectorAll('[data-rc-freq]').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        var lab = group.querySelector('[data-rc-freq-label]');
        if (lab) lab.textContent = b.dataset.rcFreqName || '';
        group.classList.remove('rc-pick--err');
        self.render();
      });
    });

    this.root.querySelectorAll('[data-rc-bump]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        b.classList.toggle('is-on');
        self.render();
      });
    });

    if (this.btn) this.btn.addEventListener('click', function () { self.checkout(); });

    var sticky = document.querySelector('[data-rc-sticky]');
    if (sticky) {
      var sBtn = sticky.querySelector('[data-rc-sticky-btn]');
      if (sBtn) sBtn.addEventListener('click', function () {
        var s = document.getElementById('rc-oferta');
        if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      var onScroll = function () { sticky.classList.toggle('is-on', window.scrollY > 420); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    this.select(this.active);
  };

  Offer.prototype.select = function (el) {
    this.active = el;
    this.tiers.forEach(function (t) {
      var on = t === el;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      if (!on) t.querySelectorAll('[data-rc-bump]').forEach(function (b) { b.classList.remove('is-on'); });
    });
    this.render();
  };

  Offer.prototype.groups = function () {
    return [].slice.call(this.active.querySelectorAll('[data-rc-pick-group]'));
  };

  Offer.prototype.picked = function () {
    return this.groups().map(function (g) {
      var b = g.querySelector('[data-rc-freq].is-on');
      return b ? b.dataset.rcVariant : null;
    });
  };

  Offer.prototype.addons = function () {
    return [].slice.call(this.active.querySelectorAll('[data-rc-bump].is-on'))
      .map(function (b) { return { id: b.dataset.rcBump, cents: money(b.dataset.rcPrice) }; })
      .filter(function (a) { return a.id && a.id !== '0'; });
  };

  Offer.prototype.total = function () {
    var t = money(this.active.dataset.rcPrice);
    this.addons().forEach(function (a) { t += a.cents; });
    return t;
  };

  Offer.prototype.render = function () {
    var total = this.total();
    var txt = brl(total);
    if (this.btn) {
      var lbl = this.btn.querySelector('[data-rc-buy-label]');
      if (lbl) lbl.textContent = this.ctaLabel + ' — ' + txt;
    }
    var s = document.querySelector('[data-rc-sticky]');
    if (s) {
      var d = this.active.dataset;
      var set = function (sel, val) { var e = s.querySelector(sel); if (e) e.textContent = val || ''; };
      set('[data-rc-sticky-name]', d.rcName);
      set('[data-rc-sticky-price]', txt);
      set('[data-rc-sticky-was]', d.rcCompare);
      var off = s.querySelector('[data-rc-sticky-off]');
      if (off) { off.textContent = d.rcOff || ''; off.style.display = d.rcOff ? 'inline-block' : 'none'; }
    }
  };

  Offer.prototype.validate = function () {
    var need = parseInt(this.active.dataset.rcPicks || '0', 10);
    if (!need) return true;
    var groups = this.groups();
    var missing = null;
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].querySelector('[data-rc-freq].is-on')) { missing = groups[i]; break; }
    }
    if (!missing) return true;

    missing.classList.remove('rc-pick--err');
    void missing.offsetWidth;
    missing.classList.add('rc-pick--err');
    missing.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var b = this.btn, self = this;
    if (b) {
      var lbl = b.querySelector('[data-rc-buy-label]');
      b.classList.remove('rc-btn--shake');
      void b.offsetWidth;
      b.classList.add('rc-btn--shake');
      if (lbl) lbl.textContent = groups.length > 1 ? 'Escolha as duas frequências' : 'Escolha a sua frequência';
      clearTimeout(this._e);
      this._e = setTimeout(function () {
        b.classList.remove('rc-btn--shake');
        self.render();
      }, 2400);
    }
    return false;
  };

  Offer.prototype.checkout = function () {
    if (this.busy) return;
    if (!this.validate()) return;

    var ids = (this.active.dataset.rcLines || '').split(',');
    this.picked().forEach(function (v) { if (v) ids.push(v); });
    this.addons().forEach(function (a) { ids.push(a.id); });

    var counts = {};
    ids.map(function (i) { return String(i).trim(); })
       .filter(function (i) { return i && i !== '0'; })
       .forEach(function (i) { counts[i] = (counts[i] || 0) + 1; });

    var parts = Object.keys(counts).map(function (i) { return i + ':' + counts[i]; });
    if (!parts.length) return;

    this.busy = true;
    this.btn.disabled = true;
    var lbl = this.btn.querySelector('[data-rc-buy-label]');
    if (lbl) lbl.textContent = 'Um momento...';
    window.location.href = '/cart/' + parts.join(',') + '?checkout';
  };

  function offers() {
    document.querySelectorAll('[data-rc-offer]').forEach(function (r) {
      if (claim(r, 'rcBound')) new Offer(r);
    });
  }

  /* ═══ ANTES / DEPOIS ═══ */
  function beforeAfter() {
    document.querySelectorAll('[data-rc-ba]').forEach(function (root) {
      if (!claim(root, 'rcBound')) return;
      var after = root.querySelector('[data-rc-ba-after]');
      var handle = root.querySelector('[data-rc-ba-handle]');
      if (!after || !handle) return;
      var dragging = false;

      function set(pct) {
        pct = Math.max(2, Math.min(98, pct));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }
      function fromX(x) {
        var r = root.getBoundingClientRect();
        set((x - r.left) / r.width * 100);
      }
      function down(e) {
        dragging = true;
        fromX(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function move(e) {
        if (!dragging) return;
        if (e.touches) { fromX(e.touches[0].clientX); }
        else { e.preventDefault(); fromX(e.clientX); }
      }
      function up() { dragging = false; }

      root.addEventListener('mousedown', down);
      root.addEventListener('touchstart', down, { passive: true });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', up);
      window.addEventListener('touchend', up);

      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(handle.style.left) || 50;
        if (e.key === 'ArrowLeft') { e.preventDefault(); set(cur - 4); }
        if (e.key === 'ArrowRight') { e.preventDefault(); set(cur + 4); }
      });
      set(50);
    });
  }

  /* ═══ CARROSSEL DE DEPOIMENTOS ═══ */
  function rails() {
    document.querySelectorAll('[data-rc-rail].rc-tst--rail').forEach(function (rail) {
      if (!claim(rail, 'rcBound')) return;
      var dots = rail.parentNode.querySelector('[data-rc-rail-dots]');
      var cards = [].slice.call(rail.children);
      if (!dots || cards.length < 2) return;

      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rc-rail__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Depoimento ' + (i + 1));
        b.addEventListener('click', function () {
          rail.scrollTo({ left: cards[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });

      var t;
      rail.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var mid = rail.scrollLeft + rail.clientWidth / 2;
          var best = 0, bestD = Infinity;
          cards.forEach(function (c, i) {
            var d = Math.abs((c.offsetLeft - rail.offsetLeft) + c.offsetWidth / 2 - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          [].slice.call(dots.children).forEach(function (d, i) {
            d.classList.toggle('is-on', i === best);
          });
        }, 60);
      }, { passive: true });
    });
  }

  /* ═══ FAQ ═══ */
  function faq() {
    document.querySelectorAll('[data-rc-faq]').forEach(function (list) {
      if (!claim(list, 'rcBound')) return;
      var btns = [].slice.call(list.querySelectorAll('.rc-faq__q'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') === 'true';
          btns.forEach(function (x) {
            x.setAttribute('aria-expanded', 'false');
            if (x.nextElementSibling) x.nextElementSibling.classList.remove('is-open');
          });
          if (!open) {
            b.setAttribute('aria-expanded', 'true');
            if (b.nextElementSibling) b.nextElementSibling.classList.add('is-open');
          }
        });
      });
    });
  }

  /* ═══ ABAS DO SELETOR DE FREQUÊNCIA ═══ */
  function tabs() {
    document.querySelectorAll('[data-rc-tabs]').forEach(function (root) {
      if (!claim(root, 'rcBound')) return;
      var btns = [].slice.call(root.querySelectorAll('[data-rc-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-rc-panel]'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-on'); });
          panels.forEach(function (p) { p.classList.remove('is-on'); });
          b.classList.add('is-on');
          var p = root.querySelector('[data-rc-panel="' + b.dataset.rcTab + '"]');
          if (p) p.classList.add('is-on');
        });
      });
    });
  }

  /* ═══ ESTOQUE ═══ */
  function stock() {
    document.querySelectorAll('[data-rc-stock]').forEach(function (el) {
      if (!claim(el, 'rcBound')) return;
      var after = el.dataset.rcStockAfter;
      var delay = (+el.dataset.rcStockDelay || 15) * 1000;
      if (after) setTimeout(function () {
        var t = el.querySelector('span');
        if (t) t.textContent = after;
      }, delay);
    });
  }

  /* ═══ REVEAL ═══ */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = [].slice.call(document.querySelectorAll('.rc-reveal'));
    if (!els.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function boot() {
    drawer(); gallery(); offers(); beforeAfter(); rails(); faq(); tabs(); stock(); reveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
